import { render, staticRenderFns } from "./refundDetailDialogGoods.vue?vue&type=template&id=23ffdfac&scoped=true&"
import script from "./refundDetailDialogGoods.vue?vue&type=script&lang=js&"
export * from "./refundDetailDialogGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ffdfac",
  null
  
)

export default component.exports